import React, { useEffect, useRef, useState, memo, useDeferredValue } from 'react';
import bem from 'utils/bem';
import Icon from 'components/Icon';
import Text from 'components/Text';
import useCart from './useCart';

import './index.sass';
import { useDebounce } from 'components/CartWidget/useDebounce';
import { Link } from 'react-router-dom';

const { cnBlock, el } = bem('cart-widget')

const getAmountFromCart = (cart) => cart.map(x => x.amount).reduce((a, b) => a + b, 0);

function tryParse(value) {
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
}

const CartWidget = ({ className, mod = 'green' }) => {
    const { cart } = useCart();
    const existing = getAmountFromCart(JSON.parse(localStorage.getItem('oc')) || []);
    const newSum = getAmountFromCart(tryParse(cart));
    const deferredNewSum = useDebounce(newSum, 200);
    const [ sum, setSum ] = useState(existing);
    const amount = newSum - sum > 0 ? deferredNewSum - sum : newSum - sum;

    const newCounterRef = useRef(null);
    const newCounterCircleRef = useRef(null);
    const deferredSum = useDeferredValue(sum);

    const newCounterFrames = [
        { fontSize: '0', transform: 'translate(-50%, -50%)' },
        { fontSize: '16px', transform: 'translate(-50%, -50%)' },
        { fontSize: '10px', transform: 'translate(-6.25%, -6.25%)' }
    ]

    const newCounterCircleFrames = [
        { transform: 'scale(0)' },
        { transform: 'scale(1)' },
        { transform: 'scale(0.5)' },
    ]

    const duration = 600;
    const easing = 'cubic-bezier(0,.57,.98,.24)';

    useEffect(() => {
        if (amount > 0 && sum !== newSum) {
            newCounterRef.current.animate(newCounterFrames, { duration, easing });
            newCounterCircleRef.current.animate(newCounterCircleFrames, { duration, easing })
                .finished
                .then(() => {
                    setSum(oldSum => oldSum + amount);
                });
        } else {
            setSum(oldSum => oldSum + amount);
        }
    }, [ amount ]);


    const NewCounter = memo(() => {
        return (
            <div className={ el('new-counter') } ref={ newCounterRef }>
                <div className={ el('new-counter-circle') } ref={ newCounterCircleRef }></div>
                <Text>{ amount }</Text>
            </div>
        )
    })

    const ExistingCounter = memo(() => {
        return (
            <div className={ el('existing-counter') }>
                <Text>{ deferredSum }</Text>
            </div>
        )
    })

    return (
        <Link className={ el('container', { 'hidden': newSum === 0 }) } to={'/cart'}>
            <div className={ cnBlock(className, mod) }>
                <Icon name={ 'shopping-cart' }/>
                <NewCounter/>
                { deferredSum > 0 && <ExistingCounter/> }
            </div>
            <div className={ el('expander') }/>
        </Link>
    )
}

export default memo(CartWidget);
